// vue
import { ref } from 'vue';

// WsLastCycle
import WsLastCycle, { WsLastCycleMessage } from '@services/trade-statistic/ws-last-cycle';

// cookie
import { useCookies } from 'vue3-cookies';

interface IConnect {
  botId: number | string;
  callBack?: (data: WsLastCycleMessage) => void;
}

export const useWsLastCycle = () => {
    const ws = ref<WsLastCycle | null>(null);

    const useWsLastCycleConnect = ({ botId, callBack }: IConnect) => {
        const { cookies } = useCookies();
        const rbSession = cookies.get('rb_session');

        if (ws.value?.isConnected()) return;

        ws.value = new WsLastCycle(rbSession, botId);

        if (callBack) ws.value.addListener(callBack);

        ws.value.connect();
    };

    const useWsLastCycleDisconnect = () => {
    ws.value?.disconnect();
    ws.value = null;
    };

    return { useWsLastCycleConnect, useWsLastCycleDisconnect };
};